import { SelfContainedCommand, CommandExecutionContext } from '../../../types/commands';
import { StandardToolResult, createSuccessResult, createErrorResult } from '../../../types/standardToolResults';
import useSpaceStore from '../../../stores/spaceStore';

export const openAPIConnectionsCommand: SelfContainedCommand = {
  id: 'open_api_connections',
  description: `🔌 Open API Connections Manager
  
Manage external API integrations and connections.

Features:
- Browse available API templates
- Set up new connections
- View existing connections
- Edit connection details`,
  
  autonomyLevel: 'auto',
  visualTreatment: 'demonstrative',
  
  schema: {
    parameters: [
      {
        name: 'spaceId',
        type: 'string',
        description: 'Space ID to open app in',
        required: false
      }
    ]
  },
  
  examples: {
    good: [
      {
        input: {},
        expectedOutput: {
          status: 'success',
          message: 'Opened API Connections Manager',
          format: 'plaintext',
        },
        description: 'Open API Connections Manager',
      },
    ],
    bad: [],
  },
  
  handler: async (params: any, context: CommandExecutionContext): Promise<StandardToolResult> => {
    try {
      await useSpaceStore.getState().actions.createWindow({
        appType: 'api-connections',
      });
      
      return createSuccessResult(
        'Opened API Connections Manager'
      );
    } catch (error: any) {
      return createErrorResult(
        'Failed to open API Connections Manager',
        error
      );
    }
  }
};
